// removed by extract-text-webpack-plugin
module.exports = {"setup-wel-container":"index__setup-wel-container___3sQkv","setup-wel-content":"index__setup-wel-content___5tjBg","wel-text":"index__wel-text___11zyi"};


//////////////////
// WEBPACK FOOTER
// ./src/views/Setup/WelcomePage/index.less
// module id = 1836
// module chunks = 3